module.exports = __webpack_public_path__ + "img/Retail3.28f62759.png";